import { Center, Divider, Flex, Spinner, Stack } from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory, useParams } from 'react-router';
import * as yup from 'yup';
import { Button, Footer, Heading, Input, Select } from '~/components';
import {
  useCompany,
  useCompanyGroupsAsSelect,
  useStates,
  useUpdateCompany,
} from '~/hooks';
import { CompanyForm as CompanyFormType } from '~/types';

export interface Item {
  label: string;
  value: string;
}

const validationFormSchema = yup.object().shape({
  nm_fantasia: yup.string().required('Nome fantasia obrigatório'),
  nm_razaosocial: yup.string().required('Razão social obrigatório'),
});

export const CompanyForm: React.VFC = () => {
  const history = useHistory();
  const { register, handleSubmit, reset, formState } = useForm({
    resolver: yupResolver(validationFormSchema),
  });
  const { errors } = formState;
  const { companyId } = useParams<{ companyId: string }>();
  const {
    data,
    isError,
    isLoading: isCompanyLoading,
  } = useCompany(Number(companyId));
  const { data: states, isLoading: isStatesLoading } = useStates();
  const { data: groups, isLoading: isGroupsLoading } = useCompanyGroupsAsSelect(
    {},
    9999,
  );
  const updateCompany = useUpdateCompany();
  const [isFetching, setFetching] = useState(false);

  const isLoading = isCompanyLoading || isStatesLoading || isGroupsLoading;

  useEffect(() => {
    if (data) {
      const {
        nm_endereco,
        nu_endereco,
        ds_complementoendereco,
        nm_cidade,
        id_estado,
        id_grupoeconomico,
        nm_razaosocial,
        nm_fantasia,
      } = data;

      reset({
        nm_fantasia,
        nm_razaosocial,
        nm_endereco,
        nu_endereco,
        ds_complementoendereco,
        nm_cidade,
        id_estado,
        id_grupoeconomico,
      });
    }
  }, [data, isLoading, isError]);

  async function handleUpdate(formData: CompanyFormType) {
    console.log({ formData });

    if (data?.id_empresa) {
      setFetching(true);
      updateCompany.mutateAsync({ id: data.id_empresa, formData }).then(() => {
        setFetching(false);
        history.goBack();
      });
    }
  }

  return (
    <Stack as="form" onSubmit={handleSubmit(handleUpdate)}>
      <Flex flexDir="column" justify="space-between" height="fit-content">
        <Flex flexDir="column" px="8" py="4" minH="calc(100vh - 127px)">
          <Heading hasBackButton>
            Editar Empresa - {data?.nm_razaosocial || data?.cnpjFormatado}
          </Heading>
          <Flex
            flexDir={{ md: 'row', sm: 'column' }}
            w="100%"
            py={9}
            gridGap="12"
          >
            <Stack gridGap={6} bg="white" maxW={300} w="100%">
              <Stack gridGap={4}>
                <Heading fontSize="md">Dados Gerais</Heading>
                <Input
                  name="nm_razaosocial"
                  type="text"
                  label="Razão Social"
                  register={register}
                  error={errors?.nm_razaosocial}
                />
                <Input
                  name="nm_fantasia"
                  type="text"
                  label="Nome Fantasia"
                  register={register}
                  error={errors?.nm_fantasia}
                />
              </Stack>
              <Stack gridGap={4}>
                <Heading fontSize="md">Endereço</Heading>
                <Input
                  name="nm_endereco"
                  type="text"
                  label="Endereço"
                  register={register}
                  fontSize="14px"
                />
                <Input
                  name="nu_endereco"
                  type="number"
                  label="Número"
                  register={register}
                  fontSize="15px"
                />
                <Input
                  name="ds_complementoendereco"
                  type="text"
                  label="Complemento"
                  register={register}
                  fontSize="15px"
                />
                <Input
                  name="nm_cidade"
                  type="text"
                  label="Cidade"
                  register={register}
                  fontSize="13px"
                />
                <Select
                  name="id_estado"
                  placeholder="Selecione"
                  label="Estado"
                  register={register}
                  error={errors.state}
                  fontSize="15px"
                >
                  {!isStatesLoading &&
                    states?.map(state => (
                      <option key={state.value} value={state.value}>
                        {state.label}
                      </option>
                    ))}
                </Select>
              </Stack>
            </Stack>
            <Center
              position="relative"
              bottom="0"
              display={{ md: 'block', sm: 'none' }}
            >
              <Divider orientation="vertical" borderColor="gray.300" />
            </Center>
            <Stack gridGap={6} bg="white" maxW={300} w="100%">
              <Select
                name="id_grupoeconomico"
                placeholder="Selecione"
                label="Grupo Econômico"
                register={register}
                error={errors.state}
                fontSize="15px"
              >
                {!isGroupsLoading &&
                  groups?.map(group => (
                    <option key={group.value} value={group.value}>
                      {group.label}
                    </option>
                  ))}
              </Select>
            </Stack>
          </Flex>
        </Flex>
      </Flex>
      <Stack bottom="0" position="sticky">
        <Footer>
          <Button variant="secondary" onClick={() => history.goBack()}>
            Cancelar
          </Button>
          <Button type="submit" isDisabled={isFetching}>
            Alterar
            {isFetching && <Spinner style={{ marginLeft: '10px' }} />}
          </Button>
        </Footer>
      </Stack>
    </Stack>
  );
};
